import { getFullUrl } from 'hubspot-url-utils';
const HS_APP = getFullUrl('app');
export const getInboxConnectPath = portalId => `/inbox-connect/${portalId}`;
export const GMAIL_OAUTHOR_BASE = `${HS_APP}/oauthor/v1/google/start`;
export const OUTLOOK_365_OAUTHOR_BASE = `${HS_APP}/oauthor/v1/office365/start`;
export const OUTLOOK_365_GCC_OAUTHOR_BASE = `${HS_APP}/oauthor/v1/office365gcchigh/start`;
export const INSTALL_PAGE = (portalId, provider = 'unknown') => `${HS_APP}/settings/${portalId}/user-preferences/email?installwizardprovider=${provider}`;